import Decimal from "decimal.js";
import { Currency } from "../utils/Currency";
import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isBetween from "dayjs/plugin/isBetween";
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(isBetween);
export class Fee {
    id;
    jsTermNumber;
    _type;
    _amount;
    _percentage;
    _basedOn;
    _description;
    _metadata;
    jsAmount;
    jsPercentage;
    _active = true;
    jsActive = true;
    constructor(params) {
        this.id = Math.random().toString(36).substr(2, 9);
        this.type = params.type;
        if (params.amount) {
            this.amount = params.amount;
        }
        if (params.percentage) {
            this.percentage = params.percentage;
        }
        if (params.basedOn) {
            this.basedOn = params.basedOn;
        }
        if (params.description) {
            this.description = params.description;
        }
        if (params.metadata) {
            this.metadata = params.metadata;
        }
        if (params.active !== undefined) {
            this.active = params.active;
        }
    }
    get type() {
        return this._type;
    }
    set type(value) {
        if (value !== "fixed" && value !== "percentage") {
            throw new Error("Fee type must be either 'fixed' or 'percentage'");
        }
        this._type = value;
    }
    get amount() {
        return this._amount;
    }
    set amount(value) {
        if (this.type !== "fixed") {
            throw new Error("Cannot set amount for a percentage-based fee");
        }
        this._amount = value !== undefined ? new Currency(value) : undefined;
        this.jsAmount = this._amount?.toNumber();
    }
    get percentage() {
        return this._percentage;
    }
    set percentage(value) {
        if (this.type !== "percentage") {
            throw new Error("Cannot set percentage for a fixed amount fee");
        }
        this._percentage = value !== undefined ? new Decimal(value) : undefined;
        this.jsPercentage = this._percentage?.toNumber();
    }
    get basedOn() {
        return this._basedOn;
    }
    set basedOn(value) {
        if (value !== undefined && value !== "interest" && value !== "principal" && value !== "totalPayment") {
            throw new Error("Fee basedOn must be either 'interest', 'principal', or 'totalPayment'");
        }
        this._basedOn = value;
    }
    get description() {
        return this._description;
    }
    set description(value) {
        this._description = value;
    }
    get metadata() {
        return this._metadata;
    }
    set metadata(value) {
        this._metadata = value;
    }
    get active() {
        return this._active;
    }
    set active(value) {
        this._active = value;
        this.jsActive = value;
    }
    updateModelValues() {
        if (this.type === "fixed") {
            if (this.jsAmount !== undefined) {
                this.amount = this.jsAmount;
            }
            else {
                this.amount = undefined;
            }
        }
        else if (this.type === "percentage") {
            if (this.jsPercentage) {
                this.percentage = this.jsPercentage;
            }
            else {
                this.percentage = undefined;
            }
        }
        this.active = this.jsActive;
    }
    updateJsValues() {
        this.jsAmount = this.amount?.toNumber();
        this.jsPercentage = this.percentage?.toNumber();
        this.jsActive = this.active;
    }
    get json() {
        return {
            type: this.type,
            amount: this.amount?.toNumber(),
            percentage: this.percentage?.toNumber(),
            basedOn: this.basedOn,
            description: this.description,
            metadata: this.metadata,
            active: this.active,
        };
    }
}
